import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const LabGroupMembers = ({members,fetchLabGroups}) => {
    // console.log("The members are:",members)
    const {university_name,dean_name,department_name,lab_name}=useParams()
    const navigate=useNavigate()
    
    const handleDelete = async (id) => {

    const confirmDelete = window.confirm("Are you sure you want to delete this Lab group member?");
    
    if (!confirmDelete) {
        return; // Stop if user clicks Cancel
    }

    try {
        const res = await axios.delete(
            `${BASE_URL}/marketplace/university/labhead/group/member/${id}/`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
            }
        );

        if (res.status === 204) {
            alert("Lab group member Deleted Successfully");
            fetchLabGroups();
        }

    } catch (error) {
        console.log("Error while deleting lab group", error);
    }
};

   
  return (
    <>
        {members?.some(m => m?.profile_data) && 
    <div className="border border-gray-200 rounded-xl overflow-hidden">
       <table className="w-full">
    
         <thead className="bg-gray-50 border-b border-gray-200">
           <tr>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Profile</th>
             <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Member Name</th>
             <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Eamil</th>
             <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Role</th>
             <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Permission</th>
             <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
           </tr>
         </thead>
         <tbody className="divide-y divide-gray-200">
           { members?.map((dean) => (
             <React.Fragment key={dean.id}>
                <tr  className="hover:bg-gray-50 transition-colors">
               <td className="px-6 py-4">
                 <div className="relative w-10 h-10">
                   <img
                     src={dean?.profile_data?.profile_picture}
                     alt={dean?.profile_data?.name}
                     className="w-10 h-10 rounded-xl object-cover border border-gray-200"
                   />
                   <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                 </div>
               </td>
               <td className="px-6 py-4">
                 <p className="text-sm font-medium text-gray-900">{dean?.profile_data?.name}</p>
               </td>
               <td className="px-6 py-4">
                 <p className="text-sm font-medium text-gray-900">{dean?.profile_data?.email}</p>
               </td>
               <td className="px-6 py-4">
                 <p className="text-sm font-medium text-gray-900">{dean?.member_role}</p>
               </td>
               <td className="px-6 py-4">
                 <p className="text-sm font-medium text-gray-900">{dean?.member_permission}</p>
               </td>
               {/* <td className="px-6 py-4">
                 <p className="text-sm text-gray-600 overflow-hidden text-ellipsis line-clamp-2">{dean?.description}</p>
               </td>
                <td className="px-6 py-4">
                 <p className="text-sm text-gray-600 overflow-hidden text-ellipsis line-clamp-2">{dean?.description}</p>
               </td> */}
               <td className="flex gap-2 px-6 py-4">
                 {/* <button
                      onClick={() => navigate(`/marketplace/${university_name}/${dean_name}/${department_name}/${lab_name}/labhead/lab_group/member/add/${dean?.id}`)}
                       className="px-3 py-2 bg-[#0f6abf] whitespace-nowrap text-white text-xs font-medium rounded-lg hover:bg-[#0a5ca8] transition-colors flex items-center gap-1"
                     >
                       <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                       </svg>
                       Add Member
                     </button> */}
   
                     <button
                       onClick={()=> navigate( `/marketplace/${university_name}/${dean_name}/${department_name}/${lab_name}/labhead/lab_group/member/edit/${dean?.id}`)}
                       className="w-9 h-9 flex items-center justify-center bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                       title="Edit Module"
                     >
                       <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                       </svg>
                     </button>
   
                     <button
                       onClick={()=>handleDelete(dean?.id)}
                       className="w-9 h-9 flex items-center justify-center bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors"
                       title="Delete Module"
                     >
                       <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                       </svg>
                     </button>
               </td>
             </tr>
            
             </React.Fragment>
           ))}
   
           {members?.length === 0 && (
             <tr>
               <td colSpan={4} className="px-6 py-12 text-center">
                 <div className="flex flex-col items-center">
                   <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                     <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                     </svg>
                   </div>
                   <p className="text-gray-500 font-medium">No groups found</p>
                   <p className="text-sm text-gray-400 mt-1">Add a {lab_name} group to get started</p>
                 </div>
               </td>
             </tr>
           )}
         </tbody>
       </table>
     </div>
     }
    </>
  )
}

export default LabGroupMembers
